/* unplugin-vue-components disabled */import { render } from "./daily-statistics.vue?vue&type=template&id=40be8ed1"
import script from "./daily-statistics.vue?vue&type=script&lang=js"
export * from "./daily-statistics.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/amoeba-logistics-information-system-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__